export const codigoPacientes = "AR-1902 04/2020";
export const codigoMedicos = "AR-1904 04/2020";
